import { type IAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { OptionsGroupDividerText } from './OptionsGroupDividerText.tsx';

export interface IOptionsGroupRichTextAdvancedDividerTextRender {
  text?: IAdvancedRichText;
}

/**
 * Renderizza il testo avanzato e lo stile del Divider (Text)
 */
export function OptionsGroupRichTextAdvancedDividerTextRender(
  props: IOptionsGroupRichTextAdvancedDividerTextRender,
) {
  if (!props.text) return null;

  return (
    <OptionsGroupDividerText>
      <RichTextAdvancedRender inline text={props.text} />
    </OptionsGroupDividerText>
  );
}
